var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssValue},[(_vm.showChildComponent)?_vm._t("default"):(_vm.showError)?_c('div',{staticClass:"insufficientPermissionBox"},[_c('p',[_vm._v("\n      Nimate pravice za ogled vsebine.\n    ")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bba0d28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/GlobalneKomponente/PermissionComponent.vue
// module id = nQQ5
// module chunks = 3